export function initializeFB(config, facebookLoginStatusDidChange) {
  if (window.FB) {
    init(window.FB, config, facebookLoginStatusDidChange)
    return
  }

  window.fbAsyncInit = function() {
    init(window.FB, config, facebookLoginStatusDidChange)
  }
  ;(function(d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    js = d.createElement(s)
    js.id = id
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')
}

let currentAuthSubscribe

function init(fb, config, facebookLoginStatusDidChange) {
  if (!fb) return
  fb.init(config)

  if (currentAuthSubscribe)
    fb.Event.unsubscribe('auth.authResponseChange', currentAuthSubscribe)

  currentAuthSubscribe = facebookLoginStatusDidChange
  fb.Event.subscribe('auth.authResponseChange', facebookLoginStatusDidChange)
}



// WEBPACK FOOTER //
// ./src/modules/facebook/facebookLogin.js